import { Link } from "react-router-dom";
import { site } from "@/config/site.config";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-ink">
    <div className="mx-auto max-w-6xl px-5 py-14">
      <p className="font-serif text-2xl italic text-cream sm:text-3xl">
        WILD WOMAN <span className="text-lime">MILLIONS</span>™
      </p>
      <p className="mt-3 max-w-md text-sm text-cream/60">
        Created for the woman who refuses to leave her vision inside her. Clarity is Currency™.
      </p>

      <nav className="mt-8 flex flex-wrap gap-x-8 gap-y-3 font-mono text-[11px] tracking-[0.3em]">
        <Link to="/privacy" data-testid="footer-privacy-link" className="text-cream/60 transition-colors hover:text-lime">
          PRIVACY POLICY
        </Link>
        <Link to="/terms" data-testid="footer-terms-link" className="text-cream/60 transition-colors hover:text-lime">
          TERMS
        </Link>
        <a href={site.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-contact-link" className="text-cream/60 transition-colors hover:text-lime">
          CONTACT
        </a>
      </nav>

      <p className="mt-10 max-w-3xl text-xs leading-relaxed text-cream/40">
        This experience is provided for educational and personal-development purposes. It is not medical,
        psychological, legal, or financial advice. Guided hypnosis, meditation, and breathwork may not be
        appropriate for everyone. Participate according to your own needs and consult a qualified professional
        when appropriate.
      </p>
      <p className="mt-6 font-mono text-[10px] tracking-[0.3em] text-cream/35">
        WILD WOMAN MILLIONS™ · CLARITY IS CURRENCY™ © 2026 DASHA LOVE
      </p>
    </div>
  </footer>
);
